var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Field, ObjectType } from "type-graphql";
import { Node } from "../relay.js";
import { GlobalIdScalar } from "../scalars/GlobalId.js";
import { IntervalISO } from "../types/IntervalISO.js";
import { Resource, TimestampedResource } from "./Resource.js";
let EventNode = class EventNode extends TimestampedResource {
    id;
    occurrences;
    title;
    summary;
    description;
    location;
    text() {
        return this.title;
    }
    getUniqueId() {
        return this.id.id;
    }
    static init(init) {
        return this.createInstance().withValues(init);
    }
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], EventNode.prototype, "id", void 0);
__decorate([
    Field(() => [EventOccurrenceNode], { nullable: false }),
    __metadata("design:type", Array)
], EventNode.prototype, "occurrences", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", String)
], EventNode.prototype, "title", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", Object)
], EventNode.prototype, "summary", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", Object)
], EventNode.prototype, "description", void 0);
__decorate([
    Field(() => String, { nullable: true }),
    __metadata("design:type", Object)
], EventNode.prototype, "location", void 0);
__decorate([
    Field(() => String, { nullable: false }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", String)
], EventNode.prototype, "text", null);
EventNode = __decorate([
    ObjectType({
        implements: [Node],
    })
], EventNode);
export { EventNode };
let EventOccurrenceNode = class EventOccurrenceNode extends Resource {
    id;
    interval;
    fullDay;
    static init(init) {
        const resource = this.createInstance().withValues(init);
        return resource;
    }
};
__decorate([
    Field(() => GlobalIdScalar, { nullable: false }),
    __metadata("design:type", Object)
], EventOccurrenceNode.prototype, "id", void 0);
__decorate([
    Field(() => IntervalISO, { nullable: false }),
    __metadata("design:type", IntervalISO)
], EventOccurrenceNode.prototype, "interval", void 0);
__decorate([
    Field(() => Boolean, { nullable: false }),
    __metadata("design:type", Boolean)
], EventOccurrenceNode.prototype, "fullDay", void 0);
EventOccurrenceNode = __decorate([
    ObjectType({
        implements: [],
    })
], EventOccurrenceNode);
export { EventOccurrenceNode };
//# sourceMappingURL=Event.js.map